import { render, staticRenderFns } from "./RiskReport.vue?vue&type=template&id=47ced142&scoped=true&"
import script from "./RiskReport.vue?vue&type=script&lang=ts&"
export * from "./RiskReport.vue?vue&type=script&lang=ts&"
import style0 from "./risk-report.scss?vue&type=style&index=0&id=47ced142&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ced142",
  null
  
)

export default component.exports